
import { defineComponent } from "vue"
import store from "../../services/store"
import { APP } from "../../services/store/modules/app"
import api from "../../services/api"
//@ts-expect-error
import { useToast } from "primevue/usetoast"

export default defineComponent({
  data() {
    return {
      newEndpoint: "",
      createEndpoint: false,
      username: "admin",
      password: "",
      toast: useToast()
    }
  },
  computed: {
    endpoints: () => store.state.app.endpoints,
    selectedEndpoint: {
      get() {
        return store.state.app.endpoints[store.state.app.endpoint]
      },
      set(name) {
        store.commit(APP.SELECT_ENDPOINT, { name })
      }
    },
  },
  methods: {
    /** checks if the endpoint provided is a valid endpoint */
    async testEndpoint() {
      const res = await fetch(this.getApiLocation(this.newEndpoint))
      const data = await res.json()
      if (typeof data !== "object" || data.name !== "VeniceRCON-api")
        throw new Error("invalid response received from endpoint")
    },
    /** parses the url string and tries to fetch the correct api endpoint url */
    getApiLocation(endpoint: string) {
      if (endpoint.endsWith("/")) endpoint = endpoint.slice(0, -1)
      if (endpoint.endsWith("/api")) return endpoint
      return `${endpoint}/api`
    },
    async addEndpoint() {
      await this.testEndpoint()
      store.dispatch(APP.ADD_LOCATION, { url: this.newEndpoint })
      this.newEndpoint = ""
      this.createEndpoint = false
    },
    async login() {
      try {
        await api.login(this.username, this.password)
        await this.$router.push("/dashboard")
      } catch (e) {
        this.toast.add({
          severity: "error",
          detail: "check username and password",
          summary: "login failed",
          life: 4000
        })
      }
    }
  }
})
